import { EnumCompartilhamentoDeDados } from "model/enums/enum-compartilhamento-dados";

export class CompartilhamentoDadosWebHookModel {
    constructor(
        public webhook: string  = '',
        public tipoNotificacaoWebhook: EnumCompartilhamentoDeDados = EnumCompartilhamentoDeDados.TODOS

    ) { }
}
